import { Box, Checkbox, FormControlLabel, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useCropModalContext } from '../context/crop-modal-context'
import { NumberFieldOrSpinner } from '~/components/number-spinner-field'
import { Repeat } from '@mui/icons-material'
import { SELECT_CROP_TOOLTIP_TEXT } from '../constants/crop-modal-constants'
import { TpTooltip } from '~/components'

export const CropSuccessionSection = ({ onSuccessionChange, maxSafeSuccessions }) => {
  const { cropId, open, successions, count, species, isCustomCrop } = useCropModalContext()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  if (cropId || !open) return null

  const handleEnabledChange = (e) => {
    onSuccessionChange({ ...successions, enabled: e.target.checked })
  }

  const handleCountChange = (val) => {
    onSuccessionChange({ ...successions, count: val })
  }

  const handleIntervalChange = (val) => {
    onSuccessionChange({ ...successions, intervalDays: val })
  }

  return (
    <Stack sx={{ gap: 1 }}>
      <TpTooltip followCursor placement='top' title={(!species && !isCustomCrop) ? SELECT_CROP_TOOLTIP_TEXT : ''}>
        <Box>
          <FormControlLabel
            disabled={!species && !isCustomCrop}
            control={<Checkbox checked={successions.enabled} onChange={handleEnabledChange} size="small" />}
            label={
              <Stack direction='row' sx={{ gap: 0.5, display: 'flex', alignItems: 'center' }}>
                <Repeat fontSize='small' sx={{ color: theme.palette.primary.main }} />
                <Typography variant='body1'>Succession Plant</Typography>
              </Stack>
            }
            sx={{ mr: 0 }}
          />
        </Box>
      </TpTooltip>
      {successions.enabled && (
        <Stack direction='row' sx={{ alignItems: 'center', gap: 1 }}>
          <Stack maxWidth='100px'>
            <NumberFieldOrSpinner
              label="Count"
              value={successions.count}
              min={1}
              onValueChange={handleCountChange}
              isDesktop={isDesktop}
              size="small"
            />
          </Stack>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
            Succession{successions.count > 1 ? 's' : ''} of <strong>{count} plant{count > 1 ? 's' : ''} each</strong>, every
          </Typography>
          <Stack maxWidth='100px'>
            <NumberFieldOrSpinner
              label="Interval"
              value={successions.intervalDays}
              min={1}
              onValueChange={handleIntervalChange}
              isDesktop={isDesktop}
              size="small"
            />
          </Stack>
          <Typography variant="body2">days. Based on current schedule, could do up to <strong>{maxSafeSuccessions} safely</strong></Typography>
        </Stack>
      )}
    </Stack>
  )
}
